let webAppInitData: string = ''

let token: string = '';

export const useTokensStore = function () {
    const getWebAppInitData = () => webAppInitData;

    const updateWebAppInitData = (data: string) => {
        webAppInitData = data;
    };

    const updateToken = (data: string) => {
        token = data;
    };

    const getToken = (): string => {
        return token;
    }

    return {
        getWebAppInitData,
        updateWebAppInitData,

        updateToken,
        getToken,
    };
}